import { useEffect, useState } from 'react';

function useElementPosition(elementRef: React.RefObject<HTMLElement>) {
  const [position, setPosition] = useState({ x: 0, y: 0, width: 0, height: 0 });

  useEffect(() => {
    const updatePosition = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        setPosition({
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        });
      }
    };

    updatePosition(); // Initial position
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition); // If position changes on scroll

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [elementRef]);

  return position;
}

export default useElementPosition;
